module.exports = __webpack_public_path__ + "img/84.e2248419.jpg";